const indexItems = [
  { name: '最新上映', icon: 'ri-movie-2-line', desc: '刚上线的热门新片', count: '56部' },
  { name: '高分必看', icon: 'ri-star-line', desc: '8分以上的口碑佳作', count: '234部' },
  { name: '动作冒险', icon: 'ri-rocket-line', desc: '肾上腺素飙升', count: '412部' },
  { name: '喜剧合家欢', icon: 'ri-emotion-laugh-line', desc: '欢乐解压首选', count: '389部' },
  { name: '悬疑烧脑', icon: 'ri-lightbulb-line', desc: '智商挑战专区', count: '256部' },
  { name: '科幻奇幻', icon: 'ri-planet-line', desc: '想象力的边界', count: '328部' },
  { name: '动画天地', icon: 'ri-palette-line', desc: '全年龄段动画', count: '197部' },
  { name: '怀旧经典', icon: 'ri-vidicon-line', desc: '光影中的回忆', count: '503部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-900 mb-3">
            分类索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大电影类型快速导航，精准定位您想看的高清电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/30"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-700 text-xl`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {item.name}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-foreground-500 text-xs">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}